import {gql, useLazyQuery} from "@apollo/client";

const GET_DATA = gql`
    query Division ($divisionSlug: String!, $profileId: Int) {
        division(divisionSlug: $divisionSlug, profileId: $profileId){
            id
            slug
            name
            competitionLevel
            ageGroup
            mountDistance
            pitchLimit
            gameDuration
            restingGames
            organization{
                id
                name
                slug
                activeSubscription {
                    plan {
                        name
                        features {
                            key
                        }
                    }
                }
                fields{
                    id
                    name
                    description
                    sportFacility{
                        name
                    }
                }
                organizationType{
                    code
                }
            }
            description
            logo
            sport{
                key
                name
            }
            isOpen
            activeSeason{
                id
                slug
                name
                registrationStartDate
                registrationEndDate
                startDate
                endDate
                state
                teams{
                    teamId
                    teamName
                    team{
                        logoUrl
                        players{
                            id
                            playerId
                            fullName
                            shirtNumber
                            status
                            position{
                                key
                                name
                            }
                        }
                        coaches{
                            id
                            playerId
                            fullName
                        }
                        slug
                    }
                }
                stages{
                    id
                    name
                    scheduleType
                    minGamesRequired
                    slug
                    hasResults
                    isDone
                    nextStage
                    gamesMode
                    teams
                    fields{
                        id
                        name
                    }
                    groups{
                        id
                        name
                        teams
                    }
                    stageReferees { id fullName rating }
                }
                gamesCount
                playersCount
                pointSystem{
                    winPoints
                    drawPoints
                    losePoints
                    otWinPoints
                    otLossPoints
                    useOvertime
                    forfeitWinPoints
                    forfeitLossPoints
                    forfeitWinScore
                    forfeitLossScore
                    doubleForfeitPoints
                }
                waivers{
                    id
                    title
                }
                registrationFeeType
                registrationInstallments {
                    installmentNumber
                    amount
                    dueDate
                }
                lateRegistrationUntil
                lateRegistrationFee
                isRegistrationOpen
                isLateRegistrationOpen
                isRegistrationClosed
            }
            seasons{
                id
                slug
                name
                registrationStartDate
                registrationEndDate
                startDate
                endDate
                state
                teams{
                    teamId
                    teamName
                    team{
                        logoUrl
                        players{
                            id
                            playerId
                            fullName
                            shirtNumber
                            status
                            position{
                                key
                                name
                            }
                        }
                        coaches{
                            id
                            playerId
                            fullName
                        }
                        slug
                    }
                }
                stages{
                    id
                    name
                    scheduleType
                    minGamesRequired
                    slug
                    hasResults
                    isDone
                    nextStage
                    gamesMode
                    teams
                    fields{
                        id
                        name
                    }
                    groups{
                        id
                        name
                        teams
                    }
                    stageReferees { id fullName rating }
                }
                playersCount
                pointSystem{
                    winPoints
                    drawPoints
                    losePoints
                    otWinPoints
                    otLossPoints
                    useOvertime
                    forfeitWinPoints
                    forfeitLossPoints
                    forfeitWinScore
                    forfeitLossScore
                    doubleForfeitPoints
                }
                waivers{
                    id
                    title
                }
                registrationFeeType
                registrationInstallments {
                    installmentNumber
                    amount
                    dueDate
                }
                lateRegistrationUntil
                lateRegistrationFee
                isRegistrationOpen
                isLateRegistrationOpen
                isRegistrationClosed
            }
            referees{
                id
                fullName
            }
            managers{
                id
                fullName
            }
        }
    }

`;

export default function GetDivisionDetail() {
    return useLazyQuery(GET_DATA);
};
